import { observer } from "mobx-react";
import {
  IncreaseOfShareCapitalForm,
  IncreaseOfShareCapitalType,
} from "./increaseOfShareCapitalDomain";
import { VBox } from "@/components-v2/Box";
import { MRadioButtonGroup } from "@/components-v2/RadioButton";

import { useTranslation } from "@/stores/RootStoreContext";

export const ShareIssueOrIncreaseNominalValue = observer(function ({
  form,
}: {
  form: IncreaseOfShareCapitalForm;
}) {
  const { t } = useTranslation();

  return (
    <VBox>
      <div>{t("decisions.increaseShareCapitalAgainstCash.sharesOrNominalValue.questionText")}</div>
      <MRadioButtonGroup
        name={"ShareIssueOrIncreaseNominalValue"}
        horizontal
        model={form.increaseOfShareCapitalTypeModel}
        disabled={form.isProjectLocked}
        onBlur={() => form.validate()}
      />
    </VBox>
  );
});

export const ShareIssueOrIncreaseNominalValue2 = observer(function ({
  form,
}: {
  form: IncreaseOfShareCapitalForm;
}) {
  const { t } = useTranslation();

  return (
    <VBox>
      <div>{t("decisions.increaseShareCapitalAgainstCash.sharesOrNominalValue.questionText2")}</div>
      <MRadioButtonGroup
        name={"ShareIssueOrIncreaseNominalValue"}
        model={form.increaseOfShareCapitalTypeModel}
        labelFn={(option) => {
          switch (option) {
            case IncreaseOfShareCapitalType.increaseNominalValue:
              return {
                key: "decisions.increaseShareCapitalAgainstCash.sharesOrNominalValue.increaseNominalValue",
              };
            case IncreaseOfShareCapitalType.shareIssue:
              return {
                key: "decisions.increaseShareCapitalAgainstCash.sharesOrNominalValue.newShares2",
              };
            default:
              return { translated: "" };
          }
        }}
        disabled={form.isProjectLocked}
        onBlur={() => form.validate()}
      />
    </VBox>
  );
});

export default ShareIssueOrIncreaseNominalValue;
